// Backend is hosted on Railway; the old Azure Container Apps URLs are dead.
// Values can be overridden at build time via REACT_APP_SPRING_API_BASE / REACT_APP_PYTHON_API_BASE
// (e.g. in frontend/.env.local or CI env) so a dev/staging build can point elsewhere.
const config = {
  PYTHON_API_BASE:
    process.env.REACT_APP_PYTHON_API_BASE ||
    "https://rewixx-python.wittygrass-81d5c888.eastus2.azurecontainerapps.io",
  SPRING_API_BASE:
    process.env.REACT_APP_SPRING_API_BASE ||
    "https://rewixxcloudappbeefmaniac-production.up.railway.app",
  GOOGLE_CLIENT_ID:
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    "767706837458-cq8og6herqn91jmd4voqc238v34tmonn.apps.googleusercontent.com",
};

export default config;
